import React, { useEffect, useState } from 'react';
import * as Glob from '../Globale';
import useReducerOnChange, { IReducerParentProps, FieldName } from "../hooks/ReducerOnChange";
import { CampoNumero } from '../components';

class CTest0 {
    F: number = 0;
    G: string = "";
    H: number[] = [0, 0];
    I: { [K: string]: string; } = {};
}

class CTest1 {
    A: number = 0;
    B: string = "";
    C: number[] = [0, 0];
    D: { [K: string]: string; } = {};
    Test0: CTest0 = new CTest0();
}

//Example of compatibility with BaseComponent and BasePureComponent
interface ITestComponentProps {
    Value: CTest1;
    OnChange: (e: React.FormEvent<any> | string, valore: any) => any;
}
class TestComponentA extends React.Component<ITestComponentProps, {}> {
    constructor(props: ITestComponentProps) {
        super(props);
    }

    public render() {
        return <div>
            A: {this.props.Value.A}-B: {this.props.Value.B}-
            <input type="text" value={this.props.Value.A} id="A" onChange={(e) => this.props.OnChange(Object.assign({}, e), undefined)} />
            <input type="button" value={this.props.Value.B.length == 0 ? "Click" : this.props.Value.B} onClick={(e) => this.props.OnChange("B", this.props.Value.B + "!")} />
        </div>;
    }
}

const TestComponentB: React.FC<ITestComponentProps> = (props) => {
    return <div>
        A: {props.Value.A}-B: {props.Value.B}-
        <input type="text" value={props.Value.A} id="A" onChange={(e) => props.OnChange(Object.assign({}, e), undefined)} />
        <input type="text" value={props.Value.A} id="A" onChange={(e) => props.OnChange(Object.assign({}, e), undefined)} />
        <input type="button" value={props.Value.B.length == 0 ? "Click" : props.Value.B} onClick={(e) => props.OnChange("B", props.Value.B + "!")} />
    </div>;
}

const TestComponentTest1: React.FC<IReducerParentProps<CTest1>> = (props) => {
    const [Parent, setParent] = [props.Reducer, props.setReducer];

    return <div>
        A: {Parent.A}-B: {Parent.B}-
        <input type="text" value={Parent.A} id={FieldName(props, "A")} onChange={(e) => setParent({ Type: "OnChangeFromForm", Target: e.currentTarget })} />
        <input type="text" value={Parent.A} id={FieldName(props, "A")} onChange={(e) => setParent({ Type: "OnChangeFromEvent", Event: Object.assign({}, e) })} />
        <input type="button" value={Parent.C.length == 0 ? "Click" : Parent.C[0]} onClick={(e) => setParent({ Type: "OnChangeFromValue", Name: "C[0]", Value: Date.now() - 1569961690824 })} />
        <input type="button" value={"F: " + Parent.Test0.F} onClick={(e) => setParent({ Type: "OnChangeFromValue", Name: FieldName(props, "Test0.F"), Value: Date.now() - 1569961690824 })} />
        <input type="button" value={"H[0]: " + Parent.Test0.H[0].toString()} onClick={(e) => setParent({ Type: "OnChangeFromValue", Name: FieldName(props, "Test0.H[0]"), Value: Date.now() - 1569961690824 })} />
    </div>;
}

const TestComponentTest0: React.FC<IReducerParentProps<CTest0>> = (props) => {
    const [Parent, setParent] = [props.Reducer, props.setReducer];

    return <div>
        F: {Parent.F}-G: {Parent.G}-
        <input type="text" value={Parent.F} id={FieldName(props, "F")} onChange={(e) => setParent({ Type: "OnChangeFromForm", Target: e.currentTarget })} />
        <input type="text" value={Parent.G} id={FieldName(props, "G")} onChange={(e) => setParent({ Type: "OnChangeFromEvent", Event: Object.assign({}, e) })} />
        <input type="button" value={Parent.F} onClick={(e) => setParent({ Type: "OnChangeFromValue", Name: FieldName(props, "F"), Value: Date.now() - 1569961690824 })} />
        <input type="button" value={Parent.H[0]} onClick={(e) => setParent({ Type: "OnChangeFromValue", Name: FieldName(props, "H[0]"), Value: Date.now() - 1569961690824 })} />
    </div>;
}

export const Test1: React.FC<Glob.IRouteGlobaleProps> = (props) => {
    const [Test1, setTest1] = useReducerOnChange<CTest1>(new CTest1());
    const [Test1Array, setTest1Array] = useReducerOnChange<CTest1[]>([]);

    useEffect(() => {
        Test1.D["B"] = (Date.now() - 1569961690824).toString();

        <span>Set the whole value</span>
        setTest1({
            Type: "Set", Value: Test1
        });

        let Test1Array: CTest1[] = [];
        Test1Array.push(new CTest1());
        Test1Array.push(new CTest1());
        Test1Array.push(new CTest1());

        <span>Set the whole value</span>
        setTest1Array({
            Type: "Set", Value: Test1Array
        });

        <span>Set a single value with OnChangeFromValue</span>
        setTest1Array({ Type: "OnChangeFromValue", Name: "0.A", Value: 123 });

    }, []);

    function ClickA() {
        <span>Set a single value with OnChangeFromValue</span>
        setTest1({ Type: "OnChangeFromValue", Name: "C.1", Value: Test1.C[1] + 1 });
    }

    function ClickDict() {
        <span>Set a single value with OnChangeFromValue</span>
        setTest1({ Type: "OnChangeFromValue", Name: "D[A]", Value: (Date.now() - 1569961690824).toString() });
    }


    function CampoNumeroMemo() {
        console.warn("CampoNumeroMemo executed");
        return <>
            <div>CampoNumeroMemo</div>
            <CampoNumero Id="A" Valore={Test1.A}
                OnChange={(e, v) => setTest1({ Type: "OnChangeFromHybrid", NameEvent: Object.assign({}, e), Value: v })}
                Name="A" Precisione={2} />
        </>
    }

    let Memo = React.useMemo(() => CampoNumeroMemo(), [Test1.A]);

    return (
        <div>
            <div>useReducerOnChange - Test1</div>

            <span>Simple field (number) and OnChangeFromForm</span>
            <div>Test1.A      <input type="text" value={Test1.A} id="A" onChange={e => setTest1({ Type: "OnChangeFromForm", Target: e.currentTarget })} /></div>

            <span>Simple field (string) and OnChangeFromEvent</span>
            <div>Test1.B      <input type="text" value={Test1.B} id="B" onChange={e => setTest1({ Type: "OnChangeFromEvent", Event: Object.assign({}, e) })} /></div>

            <span>Simple array and OnChangeFromForm</span>
            <div>Test1.C[0]   <input type="text" value={Test1.C[0]} id="C.0" onChange={e => setTest1({ Type: "OnChangeFromForm", Target: e.currentTarget })} /></div>

            <span>Simple array and OnChangeFromEvent</span>
            <div>Test1.C[1]   <input type="text" value={Test1.C[1]} id="C.1" onChange={e => setTest1({ Type: "OnChangeFromEvent", Event: Object.assign({}, e) })} /></div>

            {Test1.D["A"] != undefined &&
                <>
                    <span>Dictionay and OnChangeFromForm</span>
                    <div>Test1.D["A"] <input type="text" value={Test1.D["A"]} id="D[A]" onChange={e => setTest1({ Type: "OnChangeFromForm", Target: e.currentTarget })} /></div>
                </>
            }
            {Test1.D["B"] != undefined &&
                <>
                    <span>Dictionay and OnChangeFromEvent</span>
                    <div>Test1.D["B"] <input type="text" value={Test1.D["B"]} id="D[B]" onChange={e => setTest1({ Type: "OnChangeFromEvent", Event: Object.assign({}, e) })} /></div>
                </>
            }

            <span>Compatibility with BaseComponent and BasePureComponent using OnChangeFromHybrid (using class component)</span>
            <TestComponentA OnChange={(e, v) => setTest1({ Type: "OnChangeFromHybrid", NameEvent: Object.assign({}, e), Value: v })} Value={Test1} />

            <span>Compatibility with BaseComponent and BasePureComponent using OnChangeFromHybrid (using function component)</span>
            <TestComponentB OnChange={(e, v) => setTest1({ Type: "OnChangeFromHybrid", NameEvent: Object.assign({}, e), Value: v })} Value={Test1} />

            <div>CampoNumero</div>
            <CampoNumero Id="A" Valore={Test1.A}
                OnChange={(e, v) => setTest1({ Type: "OnChangeFromHybrid", NameEvent: Object.assign({}, e), Value: v })}
                Name="A" Precisione={2} />

            <span>Nested useReducerOnChange in a child component</span>
            <TestComponentTest1 Reducer={Test1} ClassName="" setReducer={setTest1} />
            <TestComponentTest0 Reducer={Test1.Test0} ClassName="Test0" setReducer={setTest1} />

            <input type="button" value="Click-C1" onClick={() => ClickA()} />

            <input type="button" value={Test1.D["A"] || "Click-Dict"} onClick={() => ClickDict()} />

            {Test1Array.length > 0 &&
                <>
                    <br />
                    <span>Array set with OnChangeFromForm</span>
                    <div>Test1Array[0].A    <input type="text" value={Test1Array[0].A} id="0.A" onChange={e => setTest1Array({ Type: "OnChangeFromForm", Target: e.currentTarget })} /></div>
                    <span>Array set with OnChangeFromEvent</span>
                    <div>Test1Array[1].B    <input type="text" value={Test1Array[1].B} id="1.B" onChange={e => setTest1Array({ Type: "OnChangeFromEvent", Event: Object.assign({}, e) })} /></div>
                    <span>Array and Dictionary set with OnChangeFromForm</span>
                    <div>Test1Array[1].C[0] <input type="text" value={Test1Array[1].C[0]} id="1.C[0]" onChange={e => setTest1Array({ Type: "OnChangeFromForm", Target: e.currentTarget })} /></div>
                    <span>Array and Dictionary set with OnChangeFromEvent</span>
                    <div>Test1Array[2].C[1] <input type="text" value={Test1Array[2].C[1]} id="2.C.1" onChange={e => setTest1Array({ Type: "OnChangeFromEvent", Event: Object.assign({}, e) })} /></div>
                </>
            }

            <ul>
                <li>{Test1.A}</li>
                <li>{Test1.B}</li>
                <li>{Test1.C.map((v, i) => <span key={i}>{v}-</span>)}</li>
                <li>{Test1.D["A"]}</li>
                <li>{Test1.D["B"]}</li>
            </ul>
            <div>Test1Array</div>
            {Test1Array.map((v, i) =>
                <ul key={i}>
                    <li>{v.A}</li>
                    <li>{v.B}</li>
                    <li>{v.C.map((v, i) => <span key={i}>{v}-</span>)}</li>
                </ul>
            )}
            MEMO1
            {Memo}
            MEMO2
            <TestRenderPros />
        </div>
    );
}


interface ITestRenderProps {
    A: string;
}

interface IRenderProps {
    children(props: ITestRenderProps): React.ReactNode
}

const RenderProps: React.FC<IRenderProps> = (props) => {
    const [A, setA] = useState<ITestRenderProps>({ A: "a" });

    return <>-{props.children(A)}-</>;
}

const TestRenderPros: React.FC<{}> = (props) => {
    return <RenderProps>{renderProd => (<span>|{renderProd.A}|</span>)}</RenderProps>;
}


// WEBPACK FOOTER //
// ./src/form/Test.tsx